import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, TextField } from '@mui/material';
import React from 'react';

import { BrandAttributes } from 'app/model';

interface ReTagDialogProps extends DialogProps {
    attribute?: BrandAttributes;
    onReTag: (attribute: BrandAttributes, details: string) => void;
    onClose: Required<DialogProps>['onClose'];
}

export class ReTagDialog extends React.Component<ReTagDialogProps, { details: string }> {
    public constructor(props: ReTagDialogProps) {
        super(props);
        this.state = {
            details: props.attribute?.details ?? '',
        };
    }

    public componentDidUpdate(prevProps: ReTagDialogProps): void {
        if (prevProps.attribute?.id !== this.props.attribute?.id) {
            this.setState({ details: this.props.attribute?.details ?? '' });
        }
    }

    public render(): React.ReactNode {
        const { attribute, onReTag, ...rest } = this.props;

        return (
            <Dialog {...rest}>
                <DialogTitle>Re-tag</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        label='Details'
                        margin='dense'
                        value={this.state.details}
                        onChange={(event) => this.setState({ details: event.target.value })}
                    />
                </DialogContent>
                <DialogActions>
                    <Button color='secondary' onClick={(evt) => rest.onClose(evt, 'backdropClick')}>
                        Cancel
                    </Button>
                    <Button
                        color='primary'
                        onClick={() => {
                            if (attribute) {
                                onReTag(attribute, this.state.details);
                            }
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
